import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import locales from './locales';

class SixSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  // 页面是否展示
  @observable isActive = false;
  // 买点信息数组
  list = locales;

  mapSwiper = new BaseSwiperStore({
    name: 'sixSection',
    swiperOptions: {
      loop: true,
      spaceBetween: 0,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false,
      on: {
        progress: function (progress) {
          // console.log(progress);
        }
      }
    }
  });
  mechaTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 35,
      loop: true,
      loopedSlides: 3, // 显示的数量, 默认为3
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      allowTouchMove: false
    }
  });

  /**
   * 切换
   * @param index
   */
  onClickChangeSwiper = index => {
    this.onClickChangeContentIndex(index);
  };
  onMechaPaginationClick = e => {
    if (e.target.tagName.toLowerCase() === 'a') {
      const mechaCode = Number(e.target.getAttribute('data-mecha-code'));
      console.log('mechaCode==', mechaCode);
      this.mechaTabSwiper.onChange(mechaCode);
      this.onClickChangeSwiper(mechaCode);
      // this.changeMecha(mechaCode);
    }
  };
  /**
   * 点击切换内容轮播图的节点
   * @param index
   */
  onClickChangeContentIndex = index => {
    this.mapSwiper.onChange(index);
    // this.mechaTabSwiper.onChange(index);
  };

  use() {
    useMount(async () => {
      // this.mapSwiper.onSwiperAutoPlayChange(false);
    });
    useEffect(
      () => {
        // console.log('activeIndex==', this.mapSwiper.activeIndex);
        this.mechaTabSwiper.activeIndex = this.mapSwiper.activeIndex;
        this.mapSwiper.activeIndex = this.mechaTabSwiper.activeIndex;
      },
      [this.mapSwiper.activeIndex, this.mechaTabSwiper.activeIndex]
    );
  }
}

export default SixSectionStore;
